<script>	
	import {page} from '$app/stores';

	import MenuCategories from '$lib/components/MenuCategories.svelte';
	//import DiamondMenuCategories from '$lib/components/diamond/DiamondMenuCategories.svelte';
	//import JapaneseCategory from '$lib/components/japanese/JapaneseCategory.svelte';
	
	//import MenuCategories from './MenuCategories.svelte';
	//import MenuSection from './MenuSection.svelte';	
		
	import './styles.css';
	
	import { fade } from 'svelte/transition';	
	import { urlFor } from "../lib/core/sanity.js"

	import MenuData from "../lib/core/menuData";
	$: menuData = $MenuData;	

</script>


<svelte:head>
	
	{#if !menuData.isLoaded}
		<title>Catalogo</title>
	{:else}
		<title>{menuData.aboutUs.title}</title>
	{/if}	
</svelte:head>

<section class="main-section">	

	<div class="logo-container">
		{#if menuData.isLoaded}
			<div class="welcome"  in:fade|global="{{ delay: 300, duration: 1000}}">
				<picture>
					<source class="logo-picture" srcset={urlFor(menuData.aboutUs.logo.asset)} type="image/webp" />
					<img class="logo-picture" src={urlFor(menuData.aboutUs.logo)} alt="Logo" />
				</picture>
			</div>
		{/if}
	</div>

	{#if !menuData.isLoaded}
		<div class="loading-section" transition:fade|global>
			<span>Cargando...</span>
		</div>
	{:else}
		<MenuCategories />
	{/if}

	<a class="contact-button-floating" href="/contacto">		
		<div class="contact-button-floating-image"></div>
	</a>
	
</section>

<style lang="scss">

	
</style>
